<!--The whole content below can be removed with the new code.-->
<!--div style="text-align:center">
  <h1>
    Welcome to {{title}}!!
  </h1>
</div-->
<router-outlet *ngIf="show"></router-outlet>
<app-modal *ngIf="!isLoginPage"></app-modal>